export default __webpack_public_path__ + "static/media/gallery_03.a69fc9b6.jpg";